import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import ServiceGuidance from "components/ServiceGuidance";

const coverage = [
    {
        title: "Curățenie fațade",
        items: [
            "Spălare fațade din sticlă, metal, beton sau materiale compozite",
            "Tratamente pentru îndepărtarea depunerilor naturale și a urmelor de intemperii",
            "Curățarea suprafețelor colantate, a graffitiului sau a elementelor decorative",
        ],
    },
    {
        title: "Curățenie parcări și platforme",
        items: [
            "Spălare mecanizată a parcărilor",
            "Îndepărtarea uleiurilor, petelor și reziduurilor",
            "Curățarea rampelor, aleilor și zonelor de acces",
        ],
    },
    {
        title: "Curățenie exterioară generală",
        items: [
            "Întreținerea trotuarelor și spațiilor pietonale",
            "Colectarea deșeurilor și reziduurilor",
            "Spălarea suprafețelor exterioare",
        ],
    },
    {
        title: "Defrișări și întreținerea vegetației",
        items: [
            "Tăierea și îndepărtarea vegetației necontrolate",
            "Curățarea terenurilor și spațiilor verzi",
            "Întreținerea perimetrală a clădirilor",
        ],
    },
];

const advantages = {
    paragraphs: [
        "Îndepărtarea murdăriei, a reziduurilor și a vegetației necontrolate reduce riscul de alunecare, accidente sau deteriorări ale suprafețelor exterioare.",
        "Lucrările sunt planificate în funcție de specificul locației, cu intervenții eficiente și impact minim asupra activității zilnice sau a traficului.",
        "Utilizăm echipamente profesionale și metode adaptate suprafețelor exterioare, fațadelor și platformelor, pentru rezultate eficiente și protejarea materialelor.",
    ],
};

const advice = {
    paragraphs: [
        "Programați curățenia exterioară periodic, nu doar ocazional. Intervențiile regulate previn acumularea murdăriei, a depunerilor de poluare și degradarea suprafețelor expuse factorilor externi.",
        "Acordați atenție fațadelor și zonelor vizibile. Fațadele curate și bine întreținute contribuie direct la percepția asupra brandului și la valoarea generală a clădirii.",
        "Întrețineți parcările și zonele de acces. Curățarea regulată a parcărilor reduce riscul de accidente, deteriorarea suprafețelor și acumularea petelor persistente.",
        "Apelați la furnizori specializați pentru lucrările exterioare. Aceste lucrări necesită echipamente adecvate, experiență și respectarea normelor de siguranță.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                    Ce acoperim
                </MKTypography>
                <MKBox component="ul" pl={3} mb={5}>
                    {coverage.map(({ title, items }) => (
                        <MKBox component="li" key={title} mb={3}>
                            <MKTypography
                                variant="h4"
                                color="dark"
                                mb={1.5}
                                sx={{ textWrap: "balance" }}
                            >
                                {title}
                            </MKTypography>
                            <MKBox component="ul" pl={3}>
                                {items.map((item) => (
                                    <MKTypography
                                        component="li"
                                        variant="body1"
                                        color="text"
                                        mb={1}
                                        key={item}
                                        sx={{ textWrap: "pretty" }}
                                    >
                                        {item}
                                    </MKTypography>
                                ))}
                            </MKBox>
                        </MKBox>
                    ))}
                </MKBox>
                <ServiceGuidance advantages={advantages} advice={advice} />
            </Container>
        </MKBox>
    );
}

export default InformationHome;
